import { API } from 'aws-amplify';

const getClients = () => { // eslint-disable-line
  return API.get('AppHubAPI', `clients/active`) // eslint-disable-line
    .then(async (response) => response);
};

export default getClients;
